module.exports = __webpack_public_path__ + "static/media/olt.74b5162b.png";